import ConfettiTarget from './ConfettiTarget'
import CONFETTI_DEFAULT_PROPS from './defaults'

export { ConfettiTarget, CONFETTI_DEFAULT_PROPS }
